function changeItemFormSearch() {
  const selectSearchType = document.querySelectorAll(".select-search-type");

  if (selectSearchType.length == 0) return;

  selectSearchType.forEach((select) => {
    const selectedType = select.querySelector(".selected-type");

    const formChecks = select.querySelectorAll(".wrapper-type .form-check");

    select.addEventListener("click", () => {
      select.classList.toggle("active");
    });

    formChecks.forEach((formCheck) => {
      formCheck.addEventListener("click", (e) => {
        const input = formCheck.querySelector("input[type='radio']");
        const label = formCheck.querySelector("label");

        input.checked = true;

        selectedType.textContent = label.textContent;
      });
    });
  });
}

export { changeItemFormSearch };
